// @flow

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))

if (module.hot) {
  // $FlowFixMe
  module.hot.accept('./App.js', function () {
    console.log('Accepting the updated App module!')
    const AppNew = require('./App').default
    ReactDOM.render(<AppNew />, document.getElementById('root'))
  })
}



// WEBPACK FOOTER //
// ./src/projects/fengjr/index.js